import { put } from "redux-saga/effects";
import { submitClaimFone } from "../../Services";

export function* submitClaimFoneSaga(action) {
  const payload = action.payload;
  try {
    const res = yield submitClaimFone(payload);

    yield put({ type: "REQ_SUBMIT_CLAIM_FONE_SUCCESS", data: res.data });
  } catch (error) {
    // console.log("error register", error.message);
    yield put({ type: "REQ_SUBMIT_CLAIM_FONE_FAILED", data: error.message });
  }
}
